/* 🤖 this file was generated by svg-to-ts */
export const iconBasesepoliatestnet: {
  name: 'basesepoliatestnet';
  data: string;
} = {
  name: 'basesepoliatestnet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g clip-path="url(#basesepoliatestnet__clip0_423_64)"><path fill="#C4BFB8" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.164 0 16s7.164 16 16 16"/><path fill="#fff" d="M16.07 27.119c6.202 0 11.23-5.018 11.23-11.21 0-6.19-5.028-11.208-11.229-11.208-5.884 0-10.71 4.517-11.19 10.267h14.842v1.884H4.88c.48 5.75 5.305 10.267 11.19 10.267"/></g><defs><clipPath id="basesepoliatestnet__clip0_423_64"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
